import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import Imghero from "../../../assets/img/projects/Maison_Marline/MM-hero.png";
import { useTranslation } from "react-i18next";

function Hero() {
  const { t } = useTranslation();

  return (
    <div className="MM hero" id="hero">
      <Nav />
      <img className="ImgHero" src={Imghero} alt="Maison Marline Hero" />
      <HeroFooter
        name={t("maisonMarline.hero.name")}
        link1url=""
        link1display={false}
        link2display={false}
        link2name={t("maisonMarline.hero.link2")}
        link2url=""
      />
    </div>
  );
}

export default Hero;
